import { RouterStateSnapshot, ActivatedRouteSnapshot, Params, Data } from '@angular/router';
import { RouterStateSerializer } from '@ngrx/router-store';
import { IRouterUrlState } from '@nha/state/router/irouter-url-state.interface';
import { Injectable } from '@angular/core';

@Injectable()
export class CustomRouterStateSerializer implements RouterStateSerializer<IRouterUrlState> {
	serialize(routerState: RouterStateSnapshot): IRouterUrlState {
		return {
			url: routerState.url,
			routePath: getRoutePath(routerState.root),
			params: mergeRouteParams(routerState.root, (r) => r.params),
			queryParams: mergeRouteParams(routerState.root, (r) => r.queryParams),
			data: mergeRouteData(routerState.root)
		};
	}
}

function mergeRouteParams(route: ActivatedRouteSnapshot, getter: (r: ActivatedRouteSnapshot) => Params): Params {
	if (!route) {
		return {};
	}

	const currentParams = getter(route);
	const primaryChild = route.children.find((c) => c.outlet === 'primary') || route.firstChild;
	return Object.assign({}, currentParams, mergeRouteParams(primaryChild, getter));
}

function mergeRouteData(route: ActivatedRouteSnapshot): Data {
	if (!route) {
		return {};
	}

	const currentData = route.data;
	const primaryChild = route.children.find((c) => c.outlet === 'primary') || route.firstChild;
	return Object.assign({}, currentData, mergeRouteData(primaryChild));
}

function getRoutePath(route: ActivatedRouteSnapshot) {
	const terminalRoute = getTerminalRoute(route);
	return terminalRoute.routeConfig ? terminalRoute.routeConfig.path : '';
}

function getTerminalRoute(route: ActivatedRouteSnapshot) {
	const primaryChild = route.children.find((c) => c.outlet === 'primary') || route.firstChild;
	if (!primaryChild) {
		return route;
	} else {
		return getTerminalRoute(primaryChild);
	}
}
